import React from "react";
import {Pane} from "evergreen-ui";
import TemporaryTurnPage from "./TemporaryTurnPage";

export default function ConstructorTemporaryTurn() {

    return (
        <Pane margin={40}>
            <TemporaryTurnPage/>
        </Pane>
    );
}